(() => {
  const matrixEl = document.querySelector('[id^="SeasonMatrix-"]');
  if (!matrixEl) return;

  let matrix;
  try {
    matrix = JSON.parse(matrixEl.textContent || '{}');
  } catch {
    return;
  }

  // Normalize strings so comparisons don’t fail due to case/whitespace/unicode
  const norm = (s) =>
    String(s ?? '')
      .normalize('NFKC')
      .replace(/\u00A0/g, ' ')     // NBSP -> space
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();

  const esc = (s) => (window.CSS && CSS.escape)
    ? CSS.escape(String(s))
    : String(s).replace(/([ #;?%&,.+*~\':"!^$[\]()=>|\/@])/g, '\\$1');

  function getSeasonVariants(seasonId) {
    const node = matrix && matrix[seasonId];
    return node && Array.isArray(node.variants) ? node.variants : null;
  }

  // --- Find Size fieldset + read selected size label text ------------------

  function findSizeFieldset() {
    const fieldsets = document.querySelectorAll('fieldset.variant-picker__option');
    for (const fs of fieldsets) {
      const legend = fs.querySelector('legend');
      const legendText = (legend?.textContent || '').trim().toLowerCase();
      if (legendText.startsWith('size')) return fs;
    }
    return null;
  }

  function getLabelSpanTextForInput(input) {
    if (!input?.id) return null;
    const label = document.querySelector(`label[for="${esc(input.id)}"]`);
    if (!label) return null;

    const span = label.querySelector('span');
    const txt = (span?.textContent || label.textContent || '').replace(/\s+/g, ' ').trim();
    return txt || null;
  }

  function getSelectedSize() {
    const fs = findSizeFieldset();
    const checked = fs?.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');
    if (!checked) return null;

    return getLabelSpanTextForInput(checked) || checked.value || null;
  }

  // --- Matching logic (normalized) ----------------------------------------

  function bestVariantForColorAndSize(variants, color, size) {
    const colorKey = norm(color);
    const sizeKey = norm(size);

    const byColor = variants.filter(v => norm(v.color) === colorKey);
    if (!byColor.length) return null;

    return (
      byColor.find(v => norm(v.size) === sizeKey && v.available) ||
      byColor.find(v => norm(v.size) === sizeKey) ||
      byColor.find(v => v.available) ||
      byColor[0]
    );
  }

  function isAvailableForColorAndSize(variants, color, size) {
    const colorKey = norm(color);
    const sizeKey = norm(size);

    return variants.some(v =>
      norm(v.color) === colorKey &&
      norm(v.size) === sizeKey &&
      !!v.available
    );
  }

  // --- Update season swatches ---------------------------------------------

  function updateSeasonSwatchesForSize() {
    const size = getSelectedSize();
    if (!size) return;

    const swatches = document.querySelectorAll('a.color-swatch[data-season-id][data-color]');
    if (!swatches.length) return;

    swatches.forEach((a) => {
      const seasonId = a.getAttribute('data-season-id');
      const color = a.getAttribute('data-color');

      const variants = getSeasonVariants(seasonId);
      if (!variants) return;

      // Always clear first, then re-apply (prevents “stuck disabled”)
      a.classList.remove('is-disabled');
      a.setAttribute('aria-disabled', 'false');

      const best = bestVariantForColorAndSize(variants, color, size);
      if (best?.url) a.href = best.url;

      const ok = isAvailableForColorAndSize(variants, color, size);
      if (!ok) {
        a.classList.add('is-disabled');
        a.setAttribute('aria-disabled', 'true');
      }
    });
  }

  // --- Bind to *any* variant change (not just size fieldset events) --------

  function bind() {
    const sizeFs = findSizeFieldset();
    if (sizeFs) {
      sizeFs.addEventListener('change', updateSeasonSwatchesForSize);
      sizeFs.addEventListener('click', () => requestAnimationFrame(updateSeasonSwatchesForSize), true);
    }

    // ALSO listen on the whole product form / variant picker:
    // Prestige sometimes auto-selects and updates without a direct change event on the same element.
    const productForm =
      document.querySelector('product-form form') ||
      document.querySelector('form[id^="product-form-"]') ||
      document.querySelector('form[action*="/cart/add"]');

    if (productForm) {
      productForm.addEventListener('change', updateSeasonSwatchesForSize, true);
      productForm.addEventListener('click', () => requestAnimationFrame(updateSeasonSwatchesForSize), true);
    }

    // MutationObserver fallback: catches checked-state changes done by JS
    const moTarget = document.querySelector('.variant-picker') || productForm;
    if (moTarget) {
      const mo = new MutationObserver(() => updateSeasonSwatchesForSize());
      mo.observe(moTarget, { attributes: true, subtree: true, attributeFilter: ['class', 'checked'] });
    }

    // Initial + delayed (covers late theme hydration)
    updateSeasonSwatchesForSize();
    setTimeout(updateSeasonSwatchesForSize, 50);
    setTimeout(updateSeasonSwatchesForSize, 200);
  }

  bind();
})();